import { Button, Modal } from '@/components';

/**
 * Nested confirm dialog. Sits above SideDrawer (z-100).
 */
export function ActionConfirmModal({
  isOpen,
  onCancel,
  onConfirm,
  isPending = false,
  title,
  description,
  confirmLabel = 'Confirm',
  pendingLabel,
  variant = 'primary',
}) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={() => {
        if (!isPending) onCancel();
      }}
      title={title}
      description={description}
      size="sm"
      zIndexClass="z-[110]"
      footer={
        <>
          <Button variant="secondary" onClick={onCancel} disabled={isPending}>
            Cancel
          </Button>
          <Button variant={variant} onClick={onConfirm} disabled={isPending}>
            {isPending ? pendingLabel || `${confirmLabel}...` : confirmLabel}
          </Button>
        </>
      }
    />
  );
}
